import { useEffect } from 'react'
import { Stack, Typography, Button } from '@mui/material'
import { useNavigate } from "react-router-dom";

import { useTranslation } from 'react-i18next';

function Unauthorized() {
  const navigate = useNavigate();

  const { t } = useTranslation()

  function handleClick() {
    navigate("/");
  }

  useEffect(() => {
    document.title = t("unauthorized.page_title")
  }, [])

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100dvh',
        p: 2,
      }}
    > 
      <Typography variant='h1' color="primary" fontWeight="bold">401!</Typography>
      <Typography variant='h2'>{t("unauthorized.unauthorized_text")}</Typography>
      <Button variant="contained" size='large' sx={{ borderRadius: '10px', marginTop: 4 }} onClick={handleClick}>{t("unauthorized.back_to_home_button")}</Button>
    </Stack>
  )
}

export default Unauthorized
